<template>
  <div id="app" :class="{ 'bg-background': mobile }">
    <Header @data-cleared="dataCleared" />
    <Tabs v-if="!mobile && $route.name !== 'unvocalized'" />
    <main
      :class="{
        'mobile-content container': mobile,
        'container mt-md-2': $route.name !== 'unvocalized',
      }"
      class="main-content"
      id="main-content"
    >
      <!--TODO: update when pattern is mobile friendly-->
      <div :class="{ row: $route.name !== 'unvocalized' || mobile }">
        <div
          id="sidebar-wrap"
          class="col-lg-4"
          v-if="$route.name !== 'unvocalized' || mobile"
        >
          <aside
            class="sticky bg-light"
            id="sidebar"
            :ref="searchModel !== 'tavnit' ? 'sticky' : ''"
          >
            <small
              id="overview-link"
              ref="overveiwLink"
              class="overview-link position-absolute"
              v-if="
                !overviewMode &&
                !mobile &&
                (loading === 'Complete' || loading === 'Running')
              "
            >
              <span class="text-primary" @click="switchView">
                <i class="fas fa-arrow-right"></i>
                <span class="mx-1">סקירה כללית</span>
              </span>
              <span class="text-dark"> / {{ currentView }} </span>
            </small>

            <MainSearch v-if="searchModel !== 'tavnit'" ref="mainSearch" />
            <SearchPattern v-if="searchModel === 'tavnit'" ref="patternComp" />

            <!--<NikkudOptions v-if="$route.name === 'unvocalized' && mobile"/>-->
            <div class="{'aside-inner':searchModel!=='tavnit'}" v-if="!mobile">
              <span>
                <RhymeSettings v-if="searchModel === 'rhyme'" />
                <AssonanceAlliterationSettings v-else />
                <SemanticSearch v-if="searchModel !== 'tavnit'" />
                <SearchSettings />
                <AdvancedSettings v-if="searchModel !== 'tavnit'" />
              </span>
            </div>
          </aside>
        </div>
        <div
          :class="$route.name !== 'unvocalized' ? 'col-lg-8' : 'w-100'"
          id="results-wrap"
          ref="resultsWrap"
        >
          <router-view></router-view>
        </div>
        <PersonalList v-if="!mobile" />
      </div>
    </main>
    <button
      v-if="showBackToTop"
      @click="scrollToTop"
      class="btn btn-secondary position-fixed rounded"
    >
      <i class="fa fa-chevron-up"></i>
    </button>
  </div>
</template>
<script>
import Header from "@/components/header";
import MainSearch from "@/components/MainSearch";
import RhymeSettings from "@/components/rhymeSettings";
import AssonanceAlliterationSettings from "@/components/assonanceAlliterationSettings";
import SemanticSearch from "@/components/SemanticSearch";
import SearchSettings from "@/components/SearchSettings";
import AdvancedSettings from "@/components/advancedSettings";
import Tabs from "@/components/tabs";
import SearchPattern from "@/components/SearchPattern.vue";
import PersonalList from "@/components/PersonalList";
import { Actions } from "@/store/stateChanges";

export default {
  name: "app",
  components: {
    Header,
    MainSearch,
    RhymeSettings,
    AssonanceAlliterationSettings,
    SemanticSearch,
    SearchSettings,
    AdvancedSettings,
    Tabs,
    PersonalList,
    SearchPattern,
  },
  data() {
    return {
      showBackToTop: false,
    };
  },
  methods: {
    checkParams() {
      if (
        JSON.stringify(this.$route.query) !==
        JSON.stringify(this.$store.state.queriedData)
      ) {
        this.$store.dispatch(Actions.RELOAD_FROM_URL);
      }
    },
    dataCleared() {
      if (this.$refs.patternComp) this.$refs.patternComp.clearData();
      if (this.$refs.mainSearch) this.$refs.mainSearch.searchWord = "";
    },
    switchView() {
      this.$store.commit("SET_OVERVIEW", true);
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    onResize() {
      if (this.$route.name !== "unvocalized" && this.$refs.sticky) {
        this.$refs.sticky.style.width =
          this.$refs.sticky.parentElement.clientWidth - 30 + "px";
        this.$refs.sticky.classList.remove("position-fixed");
        if (document.getElementById("main-search"))
          document.getElementById("main-search").classList.remove("mt-0");
        if (this.$refs.overveiwLink)
          this.$refs.overveiwLink.classList.remove("d-none");
      }
      //window.scrollTo(0,0)
    },
  },
  mounted() {
    if (this.$refs.sticky) this.sidebarWidth = this.$refs.sticky.clientWidth;
    this.checkParams();
  },
  created() {
    this.$settings.hebrew = true;
    window.addEventListener("resize", this.onResize);
    window.onpopstate = () => {
      if (document.getElementsByClassName("close")[0]) {
        document.getElementsByClassName("close")[0].click();
      }
      if (
        document.getElementById("hide-mobile-tabs") &&
        document.getElementsByClassName("mobile-tabs")[0]
      ) {
        document.getElementById("hide-mobile-tabs").click();
      }
      this.$refs.mainSearch.checkParams();
    };
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    mobile() {
      return this.$mq === "xs";
    },
    hebrew() {
      return this.$settings.hebrew;
    },
    searchModel() {
      return this.$store.state.searchModel;
    },
    soundPlayWord() {
      return this.$store.state.textForCharuzitApiCall;
    },
    overviewMode() {
      return this.$store.state.displayOverview;
    },
    loading() {
      return this.$store.state.charuzitApiState;
    },
    displayConsonance() {
      return this.$store.state.preSubmissionOptions.displayConsonance;
    },
    displayAssonance() {
      return this.$store.state.preSubmissionOptions.displayAssonance;
    },
    currentView() {
      let prefix = this.hebrew
        ? this.searchModel === "rhyme"
          ? " חרוזים "
          : "מילים"
        : "";
      let viewWord = "";
      switch (this.$store.state.viewMode) {
        case "Common":
        case "TavnitCommon":
          viewWord = this.hebrew
            ? this.searchModel === "rhyme"
              ? prefix + " נפוצים"
              : prefix + " נפוצות"
            : "Common list";
          break;
        case "Bible":
        case "TavnitBible":
          viewWord = this.hebrew ? prefix + ' מהתנ"ך' : "Bible list";
          break;
        case "Default":
        case "Tavnit":
          viewWord = this.hebrew ? "הרשימה המלאה" : "Full list";
          break;
        case "NS":
          viewWord = this.hebrew ? prefix + " ללא סיומת" : "No suffix list";
          break;
        case "Long":
          viewWord = this.hebrew
            ? this.searchModel === "rhyme"
              ? prefix + " ארוכים"
              : prefix + " ארוכות"
            : "Long list";
          break;
        case "Fem":
          viewWord = this.hebrew ? prefix + "בלשון נקבה " : "Feminine list";
          break;
        case "TavnitBase":
          viewWord = this.hebrew ? "צורות יסוד נפוצות" : "Common base list";
          break;
      }
      return viewWord;
    },
  },
  watch: {
    loading() {
      this.onResize();
    },
    overviewMode() {
      this.onResize();
    },
    displayConsonance() {
      this.onResize();
    },
    displayAssonance() {
      this.onResize();
    },
  },
};
</script>

<style lang="scss">
@media (min-width: 576px) and (max-width: 991px) {
  .modal-dialog {
    max-width: 92%;
  }
  @media screen and (orientation: landscape) {
    .modal-dialog,
    .container {
      max-width: 100%;
    }
  }
}
@media (max-width: 991px) {
  #app {
    overflow-x: hidden;
    &.rotated {
      min-height: calc(100vh - 87px);
    }
  }
  html,
  body,
  #app {
    height: 100%;
  }
  html.rotated {
    //for ios orientation change
    height: 100vh;
    body,
    #app {
      height: 100vh;
    }
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1146px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .container {
    max-width: 97%;
  }
}
@font-face {
  font-family: "mfw_korentanakh_bold";
  src: url("assets/fonts/KorenTanakh-bold_MFW_FixedQQ.woff") format("woff");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "mft_narkisclassic";
  src: url("assets/fonts/mft_narkisclassic-regular.woff") format("woff");
  font-style: normal;
  font-weight: normal;
  text-rendering: optimizeLegibility;
}
@font-face {
  font-family: "mft_narkisclassic";
  src: url("assets/fonts/MFTW_NarkisClassicBold.woff") format("woff");
  font-style: normal;
  font-weight: bold;
}
.f-narkis {
  font-family: Roboto, mft_narkisclassic, sans-serif;
  line-height: 1.5;
}
.f-koren {
  font-family: mfw_korentanakh_bold;
  b {
    color: var(--primary);
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
.centered {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.overview-heading {
  margin-bottom: 8px;
  margin-top: 6px;
}
.dropdown-menu {
  max-height: 300px;
  overflow-y: hidden;
}
.dicta-dropdown .col-auto {
  font-size: 16px;
}
.popover:not(.mobile-popover) {
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
  left: 5px !important;
  border: 0;
  max-width: 332px;
  margin-bottom: 4px;
  .arrow {
    display: none;
  }
  .popover-body {
    padding: 0.5rem;
  }
}
.vue-slider-mark-step {
  background-color: transparent;
}
.vue-slider-mark-label {
  direction: ltr;
  color: #989a97;
  padding: 2px 4px;
  margin-top: 13px !important;
  line-height: 14px;
  border-radius: 2px;
}
.vue-slider-mark-label.active,
.vue-slider-mark-label-active {
  background: #d6ecff;
  color: var(--primary);
}
.vue-slider-rail {
  background: white;
  border: 1px solid #d8d8d8;
  border-radius: 2px;
  cursor: pointer;
}
#syllable-slider {
  .vue-slider-process {
    background-color: var(--primary);
  }
}
.vue-slider-process {
  background-color: white;
}
.vue-slider-dot-handle {
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);
}
.spinner-overview-wrap {
  left: 50%;
  top: 40vh;
  margin-top: -18px;
  margin-left: -18px;
  z-index: 1;
}
.notify-msg {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 238px;
  height: 50px;
  padding: 15px 8px;
  text-align: center;
  border-radius: 3px;
  box-sizing: border-box;
  background-color: #494949;
  z-index: 9999999;
  @media (max-width: 991px) {
    right: auto;
    left: 10px;
    height: auto;
    padding: 12px 8px;
  }
}
@media (min-width: 768px) {
  .no-results {
    margin-top: 35px;
  }
}
</style>
<style lang="scss" scoped>
.overview-link {
  .text-primary {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
.main-content {
  flex: auto;
  min-height: 500px;

  &.mobile-content {
    min-height: calc(100% - 147px);
  }
}
aside {
  z-index: 99;
  @media (min-width: 992px) {
    position: sticky;
    top: -40px;
    height: 100vh;
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    &::-webkit-scrollbar {
      width: 0px;
      background: transparent; /* Chrome/Safari/Webkit */
    }
  }
  @media (max-width: 991px) {
    position: static !important;
  }
  position: relative;
  top: 0;
}
button.position-fixed {
  bottom: 12px;
  right: 50px;
  z-index: 99;
}
</style>
